<template>
    <div class='franja-fuentes'>
        <ul class="row">
            <li class="fraja-fuentes__item">
                <div class="fraja-fuentes__item-hour">
                    <i :class="icon" v-if="!svg_icon"></i>
                    <img :src="icon" alt="icono-buenas-tardes" v-else>
                    <span class="fraja-fuentes__item-saludo">{{ saludo_hora }}</span>
                    <div>
                        <span class="hour">{{hours}}:</span><span class="min">{{minutes}} {{ ((this.hours >= 12) ? 'p.m' : 'a.m')}}</span>
                    </div>
                </div>
            </li>
            <li class="fraja-fuentes__item fraja-fuentes__item--line">
                <div>
                    <span class="d-none d-md-inline-block">Procesos hoy en {{ $root.paisOriginalName }}</span> <span  class="d-inline d-md-none">Procesos hoy en <span class="text-uppercase">{{ $root.alias_pais }}</span> </span> <span v-if="isVacio(contadores_fuentes)">: No hay procesos publicados en el momento</span>
                </div>
            </li>
            <li v-for="(contador, key) in contadores_fuentes" :key="key" class="fraja-fuentes__item">
                <a :href="getUrlProcesosFuentes(contador)" class="fraja-fuentes__contador" target="_blank">
                    <span class="d-none d-md-inline-block">{{ contador.nombre}} : </span> <span class="d-inline d-md-none">{{ contador.alias_fuente}} : </span> <span class="fraja-fuentes__item--claro">{{ contador.total}} procesos </span> <i class="icon-up"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import moment from "moment";
    /* eslint-disable */
    export default {
        name: 'franja-procesos-fuentes',
        data: () => ({
            hours: 0,
            minutes: 0,
            seconds: 0,
            icon: 'icon-sun',
            saludo_hora: 'Buenos días',
            contadores_fuentes: [],
            svg_icon: false
        }),
        methods: {
            /**
             * setTime
             * @description Se encarga de poner la hora , minutos y segundos por si se necesita
             * @author Alejandro Cardona
             */
            setTime () {
                setInterval(() => {
                    const date = new Date()
                    this.hours = date.getHours()
                    this.minutes = this.validateSingleDigit(date.getMinutes())
                    this.seconds = this.validateSingleDigit(date.getSeconds())
                }, 1000)
            },

            /**
             * validateSingleDigit
             * @description Se encarga de validar si hay un dato de un solo digito para ponerle el 0
             * @param digit , digito a validar
             * @author Alejandro Cardona
             */
            validateSingleDigit (digit) {
                return ('0' + digit).slice(-2)
            },

            /**
             * setIconAtTime
             * @description Setea el icono y el saludo que es dependendiendo de la hora
             * @author Alejandro Cardona
             */
            setIconAtTime () {
                this.svg_icon = false
                switch (true) {
                    case (this.hours >= 0 && this.hours <= 11):
                        this.icon = 'icon-sun'
                        this.saludo_hora = 'Buenos días'
                        break;
                    case (this.hours >= 12 && this.hours <= 18):
                        this.icon = "/icons/multicolor/afternoon.svg"
                        this.saludo_hora = 'Buenas tardes'
                        this.svg_icon = true
                        break;
                    case (this.hours >= 19 && this.hours <= 23):
                        this.icon = 'icon-night'
                        this.saludo_hora = 'Buenas noches'
                        break;
                    default:
                        break;
                }
            },

            /**
             * getContadoresFuentes
             * @description Método encargado de obtener los contadores de las fuentes
             * @author Alejandro Cardona
             */
            getContadoresFuentes() {
                axios.get(this.$root.raiz_virtual+'/fuentes', {})
                .then((response) => {
                    const result = response.data.result
                    if (response.status == 200) {
                        if (result.success && !this.isVacio(result.fuentes)) {
                            this.contadores_fuentes = result.fuentes
                        }
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
            },

            /**
             * getContadoresFuentes
             * @description Método encargado de obtener la url de los procesos
             * @param contador, datos del contador a consultar.
             * 
             * @author Alejandro Cardona
             */
            getUrlProcesosFuentes(contador) {
                return this.$root.url_laravel+'/fuente-licitacion/'+contador.nombre+'/'+contador.id_fuente+'?FechaPublicacion='+moment().format('YYYY-MM-DD');
            }
        },
        watch: {
            // Escuchantes de las horas para poner el saludo que es y el icono
            hours(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.setIconAtTime()
                }
            }
        },
        mounted () {
            this.getContadoresFuentes()
            this.setTime()
        }
    }
</script>
